import React from "react";

const DataTable = ({ headers, data, emptyMessage = "No data available" }) => (
  <div className="overflow-x-auto shadow-lg rounded-lg border border-gray-200">
    <table className="w-full bg-white text-xs">
      <thead className="bg-gray-200 border-b border-gray-200">
        <tr>
          {headers.map((header, index) => (
            <th
              key={index}
              className="px-2 py-2 text-left font-bold text-gray-700 uppercase tracking-wider text-xs"
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {data.length > 0 ? (
          data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="hover:bg-gray-50 transition-colors duration-150"
            >
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-2 py-2 text-xs text-gray-900 whitespace-nowrap"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={headers.length}
              className="px-2 py-8 text-center text-xs text-gray-500"
            >
              {emptyMessage}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default DataTable;
